export enum InvoiceItemVarianceType {
  Normal = "Normal",
  Variance = "Variance",
}
